import { render, staticRenderFns } from "./BulmaChart.vue?vue&type=template&id=34cf2d5d&"
import script from "./BulmaChart.vue?vue&type=script&lang=js&"
export * from "./BulmaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports